import React from "react";
import ReactDOM from "react-dom";
import { App, Providers } from "./shared/components/app";
import reportWebVitals from "./reportWebVitals";
import Amplify from "aws-amplify";
import awsconfig from "./aws-exports";
import "./shared/styles/globals.css";
import "./shared/styles/layer-menu.css";
import "@reach/tooltip/styles.css";
import { GlobalStyle } from "shared/styles/global";

Amplify.configure(awsconfig);

ReactDOM.render(
  <React.StrictMode>
    <Providers>
      <GlobalStyle />
      <App />
    </Providers>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
